module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAASCAYAAABIB77kAAAA7klEQVQ4je3VMUoDQRSH8V8WtbQStbcSxYAHEO8g8QgW2io2gpWVhRCwtUshOYWNpRcQLG3FQhDBPBlYYVl2Rc0kIPjBY3dml/fxBoZ/JyJmsYcN4/OIPp5aO0XEUeTlOiK0VYFuhsmqrLbsz6NIwk5lc4jtsoYZ5As4xQOecT5T++ESN5V175eiORziuJzsk+W6MAeLuMNaU6+68KDl/ScsldVIXdgb4xi/RTHJ5k38C/+E8BXv0xTeY6t8TkWYuMU6TmrJMUr3cDQh6RvOcIFdbGKQImM/czxdfRVPKYBTWuxgJcNU6fgGeGn8ig9YT/Gj2sJMcgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/baiicon/icon_zb.png
// module id = kIvU
// module chunks = 10